import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import VueMomentJS from 'vue-momentjs';
import VueCookies from 'vue-cookies'

Vue.use(VueMomentJS, moment);
Vue.config.productionTip = false;

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css' // import style (<= Swiper 5.x)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import { ApiResponseFunc } from './mixins/ApiResponseMixin'
import { AppConnectionMixin } from './mixins/AppConnectionMixin'
import { DataMixin } from './mixins/DataMixin'
import { CheckMixin } from './mixins/CheckMixin'
Vue.mixin(ApiResponseFunc);
Vue.mixin(AppConnectionMixin);
Vue.mixin(DataMixin);
Vue.mixin(CheckMixin);
Vue.use(VueCookies)


import ContentDiv from '@/components/ContentDiv.vue'
Vue.component('content-div', ContentDiv);


let isApp = false;
if(/inAppBrowser/i.test(navigator.userAgent)) isApp = true;
if(!isApp) isApp = typeof window.android !== 'undefined';
if(!isApp) isApp = typeof window.webkit !== 'undefined';

store.state.isApp = isApp;

var vm = new Vue({
  router,
  store,
  // vuetify,
  render: h => h(App)
}).$mount('#app')

window.app = vm;
